export interface PerformOrder {
  id: string;
  name: string;
  weight: number; // 总重量克数
  unit: string;
  lockPrice: number; // 预约锁定价
  currentPrice: number; // 当前参考价
  depositRatio: number; // 定金比例
  paidDeposit: number; // 已支付定金
  createTime: string;
  lockPeriod: string;
}

export const performOrder: PerformOrder = {
  id: 'ORD20250801001',
  name: '金条价',
  weight: 1000,
  unit: '克',
  lockPrice: 950.00,
  currentPrice: 1000.00,
  depositRatio: 0.03,
  paidDeposit: 28500.00,
  createTime: '2026-08-10 14:30:00',
  lockPeriod: '30天',
};

export const storageAgreement = {
  title: '黄金寄存服务协议',
  sections: [
    {
      title: '第一条 服务概述',
      body: '本协议由客户（以下简称"甲方"）与CJJY（以下简称"乙方"）就黄金实物寄存服务所订立。甲方将其合法持有的黄金实物交由乙方进行安全保管，乙方提供专业的金库存储服务，确保甲方资产安全。',
    },
    {
      title: '第二条 寄存标的',
      body: '寄存标的为甲方合法持有的AU999.9成色黄金实物，具体重量以实际入库称重为准。每件寄存黄金均配备唯一的溯源编码，甲方可通过本平台随时查询寄存状态。',
    },
    {
      title: '第三条 存储安全',
      body: '乙方承诺将甲方寄存黄金存放于符合国家金库安全标准的保管库中，配备24小时安保监控、恒温恒湿环境控制系统及多重门禁防护。乙方可为寄存黄金购买足额保险，保险费用由乙方承担。',
    },
    {
      title: '第四条 寄存费用',
      body: '寄存服务首年免收管理费。自第二年起，乙方有权按照市场标准收取合理的寄存管理费，具体费率将提前30天通知甲方。甲方可在费率调整生效前申请提货或处置，无需支付额外费用。',
    },
    {
      title: '第五条 提货与处置',
      body: '甲方可随时通过本平台申请提货或处置。申请提货时，甲方可选择到店自提或快递配送。申请处置时，乙方将按照当前市场参考价进行回购，处置款项将在确认后2个工作日内转入甲方账户余额。',
    },
    {
      title: '第六条 免责条款',
      body: '因不可抗力（如战争、自然灾害、政府行为等）导致寄存黄金损失的，乙方在已履行合理保管义务的前提下不承担赔偿责任。因甲方自身原因（如密码泄露、操作失误等）造成的损失由甲方自行承担。',
    },
    {
      title: '第七条 协议生效',
      body: '本协议自甲方通过短信验证并完成电子签名后生效，有效期与寄存服务期限一致。甲方确认已充分阅读并理解本协议全部条款，自愿接受本协议约束。',
    },
  ],
};

export interface MyGoldAsset {
  id: string;
  product: string;
  weight: number;
  status: 'stored' | 'withdrawn' | 'disposed';
  statusLabel: string;
  storeDate: string;
  code: string;
  location: string;
}

export const myGoldAssets: MyGoldAsset[] = [
  {
    id: 'VAULT001',
    product: 'AU 999.9 投资金条',
    weight: 100,
    status: 'stored',
    statusLabel: '寄存中',
    storeDate: '2026-08-14',
    code: 'AU9999-20260814-001',
    location: '北京金库',
  },
];